<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Metin"
      label-for="text"
    >
      <b-form-textarea
        id="text"
        v-model="itemData.translate.text"
        placeholder="Metin"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.text }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Button"
      label-for="button"
    >
      <b-form-input
        id="button"
        v-model="itemData.translate.button"
        placeholder="Button"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.button }}
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BFormTextarea, BAlert, BButton,
} from 'bootstrap-vue'

export default {
  name: 'Hero',
  components: {
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BAlert,
    BButton,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
